import { chatMessageTypes, ChatMessage, ChatGapMessage } from 'entities/ChatMessage';
import Collection from 'lib/Collection';
import { Backbone$Id } from 'types/typescript/Backbone';

class ChatMessages extends Collection<any> {
  initialize() {
    this.model = (
      attrs: {
        type: 'gap' | 'system' | 'attachment' | 'text' | 'broadcast' | 'phone_call';
      },
      options: any
    ) => {
      const ChatMessageType = chatMessageTypes[attrs.type] || ChatMessage;
      return new ChatMessageType(attrs, options);
    };
    this.comparator = 'seq';
  }

  static yieldMessagesForGap(gap: ChatGapMessage): Promise<ChatMessages> {
    const chatId = gap.getChatId();
    return ChatMessages.yieldMessagesForChatId(chatId, { data: gap.getParams() });
  }

  static yieldMessagesForChatId(chatId: Backbone$Id, options: any = {}): Promise<ChatMessages> {
    const messages = new ChatMessages();
    messages.url = `/chats/${chatId}/messages`;
    return messages.fetch(options);
  }
}

export default ChatMessages;
